import { Grid } from '@mui/material';
import { makeStyles, useTheme } from '@mui/styles';
import { WalletRecordExtended, WalletRecordMapped } from '@tassat/fred-extended-definitions';
import { Lock as LockIcon } from '@tassat/icon';
import { ClosedSymbol } from '@tassat/symbols';
import React from 'react';

import { LOCK_ICON_COLOR } from 'Lib/constant';
import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

interface WalletStatusCellRendererProps {
    data: WalletRecordMapped | WalletRecordExtended;
    nestedEntity?: string;
}

const getAccountRecord = (account: WalletRecordMapped | WalletRecordExtended) => {
    if ('wallet' in account) {
        return account.wallet;
    }

    return account;
};

const muiStyles = makeStyles({
    root: {
        height: '100%',
        whiteSpace: 'normal'
    }
});

const WalletStatusCellRenderer = (props: WalletStatusCellRendererProps) => {
    const { data } = props;

    const classes = muiStyles(props);
    const theme = useTheme<ApplicationMuiTheme>();
    const accountRecord = getAccountRecord(data);
    const closed = accountRecord.IsClosed;
    const locked = accountRecord.IsLocked;

    return (
        <Grid
            className={classes.root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            {closed ?
                <ClosedSymbol />
                : locked ?
                    <LockIcon
                        iconColor={theme?.app?.applicationColors.lockColor || LOCK_ICON_COLOR}
                    />
                    : null}
        </Grid>
    );
};

export default WalletStatusCellRenderer;